import { type FC, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

export interface ErrorFallbackProps {
  title: string;
  description: string;
  onRetry: () => void;
  action?: ReactNode;
}

export const ErrorFallback: FC<ErrorFallbackProps> = ({
  title,
  description,
  onRetry,
  action,
}) => {
  const { t } = useTranslation();
  return (
    <div role="alert" className="flex flex-col items-start gap-3 py-6">
      <div className="flex flex-col gap-1">
        <p className="text-fs-14 text-fg-1 font-semibold">{title}</p>
        <p className="text-fs-13 text-fg-3">{description}</p>
      </div>
      <div className="flex items-center gap-2">
        <Button type="button" variant="outline" size="sm" onClick={onRetry}>
          {t('actions.try_again')}
        </Button>
        {action}
      </div>
    </div>
  );
};
